export function handleAnimate(user, item, result, unique,demo, preview)
{

    const { x, y, w, h, id: idT, zIndex, rotation, description, mPath, mObj, strokeColor, strokeWidth, fillColor, animationSettings } = item;

    let id = (idT.trim() + `_${unique}`).trim();
        
    let aiInstruction = "";
    if (description !== "") {
      aiInstruction = `data-ai-instruction="${description}"`;
    }

    let filterId = `filter-${id}`;
    let filterStr = "";

    if(mObj)
    {
      if (mObj.isBlur || mObj.isDropShadow) {
        filterStr = `
          <filter id="${filterId}" x="-50%" y="-50%" width="200%" height="200%">
            ${mObj.isDropShadow ? `<feDropShadow dx="${mObj.shadowOffsetX}" dy="${mObj.shadowOffsetY}" stdDeviation="${mObj.shadowBlur}" flood-color="${mObj.shadowColor}" />` : ""}
            ${mObj.isBlur ? `<feGaussianBlur stdDeviation="${mObj.regularBlur}" />` : ""}
          </filter>
        `;
      }
    }


    /*
    if(mPath === undefined)
    {
      return;
    }
    */

    let rotateMode = "auto";

    if(animationSettings?.rotateMode)
    {
      rotateMode = animationSettings.rotateMode;

    }

    let repeatCount = "indefinite";
    if(animationSettings.isRepeating === false)
    {
      repeatCount = `${animationSettings?.repeatThreshold}`;
    }

    let sWidth = 0;
    if(animationSettings.pathInvisible === false)
    {
      sWidth = 1;
    }
    let durTime = "5s";

    let keySplines = "0.42 0 0.58 1"
    let ease = "spline";

    if(animationSettings?.ease===false)
    {
        ease = "linear";
    }


    if(animationSettings?.duration)
    {
      durTime = `${animationSettings.duration}s`;
    }
    
    let scaleStart = 1;
    if(animationSettings?.startScale)
    {
      scaleStart = animationSettings.startScale;
    }

    let scaleEnd = 1;
    if(animationSettings?.endScale)
    {
      scaleEnd = animationSettings.endScale;
    }

    let opacityStart = 1;
    if(animationSettings?.startOpacity)
    {
      opacityStart = animationSettings.startOpacity;
    }

    let opacityEnd = 1;
    if(animationSettings?.endOpacity)
    {
      opacityEnd = animationSettings.endOpacity;
    }


    let rotStart = 1;
    if(animationSettings?.startRotation)
    {
      rotStart = animationSettings.startRotation;
    }

    let rotEnd = 1;
    if(animationSettings?.endRotation)
    {
      rotEnd = animationSettings.endRotation;
    }


let animString =`    
                      <!-- Scale -->
                      <animateTransform
                          calcMode="${ease}"
                          keySplines="${keySplines}"
                          attributeName="transform"
                          type="scale"
                          values="${scaleStart};${scaleEnd};"
                          dur="${durTime}"
                          repeatCount="${repeatCount}"
                          additive="sum"/>

                      <!-- Rotation (custom range) -->
                      <animateTransform
                          attributeName="transform"
                          calcMode="${ease}"
                          keySplines="${keySplines}"
                          type="rotate"
                          values="${rotStart};${rotEnd};"
                          dur="${durTime}"
                          repeatCount="${repeatCount}"
                          additive="sum"/>

                      <!-- Opacity -->
                      <animate
                        calcMode="${ease}"
                        keySplines="${keySplines}"
                        attributeName="opacity"
                        values="${opacityStart};${opacityEnd};"
                        dur="${durTime}"
                        repeatCount="${repeatCount}"/>
                        `

  
    // IMAGE CASE (same clipping logic as Prect)
    let animatedContent = "";
    let fullPath = "";
    let viewBoxStr = "";

    let newViewBoxWidth = w ;  // 160 is the original width of the rectangle
    let newViewBoxHeight = h; // 120 is the original height of the rectangle
    
    // Calculate the new origin of the viewBox (this is where pan will apply)
    let newViewBoxX = item.offsetViewX;
    let newViewBoxY = item.offsetViewY;
    

    // Update the viewBox with the new values
    viewBoxStr = `${newViewBoxX} ${newViewBoxY} ${newViewBoxWidth} ${newViewBoxHeight}`;


    let gDefs = "";
    if(mObj && mObj.imageName && mObj.imageName !== "")
    {

        let iX = mObj.iX;
        let iY = mObj.iY;
        let iW = mObj.iW;
        let iH = mObj.iH;

        let refresh = "";
        if (!preview) {
          refresh = "?v=" + new Date().getTime();
        }
      
            
        let fullPath = mObj.imageName;        
        if (demo === true) {
          fullPath = `images/${mObj.imageName}`;
        }
        else
        {
          // fullPath = `${user}/${mObj.imageName}`;
          fullPath = `./${mObj.imageName}`+ refresh;
        }
  

        let path = mObj.path;
        let pathsHtml = "";

        pathsHtml = mObj.rPath.map((pathObj, index) => 
        {
            const stroke = path[index].allowStroke
              ? (path[index].strokeColor || "#000")
              : "none";
        
              const strokeWidth = path[index].allowStroke
                ? (path[index].strokeWidth || 1)
                : 0;
              
              const fill = path[index].allowFill
                ? (path[index].fillColor || "none")
                : "none";
              
              const opacity = (path[index].alpha !== undefined)
                ? path[index].alpha
                : 1;
    
              return `
                  <path 
                      d="${pathObj.d}" 
                      stroke="${stroke}" 
                      stroke-width="${strokeWidth}" 
                      fill="${fill}" 
                      opacity="${opacity}"
                      ${filterStr ? `filter="url(#${filterId})"` : ""}
                    />              
                `;
        }).join("\n");

  

        // ${mObj.rPath[0] ? `<path d="${mObj.rPath[0].d}" />` : ""}
        const clipPathDef = `
        <defs>
            <clipPath id="clip-${id}">
                ${pathsHtml}                                      
            </clipPath>
            ${filterStr}
        </defs>
        `;

        animatedContent = `
        ${clipPathDef}
        
        <g id="anim-${id}" ${filterStr ? `filter="url(#${filterId})"` : ""}>
            ${pathsHtml}
            <g  clip-path="url(#clip-${id})" ${filterStr ? `filter="url(#${filterId})"` : ""}>              
              <image
                  href="${fullPath}"
                  x="${iX}"
                  y="${iY}"
                  width="${iW}"
                  height="${iH}"
                  preserveAspectRatio="none"
              />
            </g>
            ${animString}            
        </g>
        `;
    }
    else
    {


      let path = mObj?.path;
      let pathsHtml = "";      
      if(mObj?.type==='SvgText')
      {


        let fill = "";
        let fillCss = "";

        let gradientDef = "";      
        
        if (mObj.allowFill && mObj.fillMode === "gradient") {
        
          const angle = (mObj.gradientAngle || 0) * Math.PI / 180;
        
          const dx = Math.cos(angle);
          const dy = Math.sin(angle);
        
          const gradId = `grad-${id}`;
        
          gradientDef = `
            <defs>
              <linearGradient id="${gradId}" x1="${50 - dx * 50}%" y1="${50 - dy * 50}%" x2="${50 + dx * 50}%" y2="${50 + dy * 50}%">
                <stop offset="0%" stop-color="${mObj.gradientColor1}" />
                <stop offset="100%" stop-color="${mObj.gradientColor2}" />
              </linearGradient>
            </defs>
          `;
        
          fill = `fill="url(#${gradId})"`;
          fillCss =`fill: url(#${gradId})`;
        
        } else if (item.allowFill) {
          fill = `fill="${item.fillColor}"`;
          fillCss =`fill: ${item.fillColor}`;
        } else {
          fill = `fill="transparent"`;
          fillCss = `fill: none`;
        }
  
  

        let opacity = mObj.fillAlpha;

        /*
        if(mObj.allowFill)
        {
          fill = `fill="${mObj.fillColor}"`;
          fillCss =`fill: ${mObj.fillColor}`;
        }
        else
        {
          fill = `fill="transparent"`;
          fillCss = `fill: none`;
        }
        */
          
        let stroke = "";
        let strokeCss = "";
  
        if(mObj.allowStroke)
        {
          stroke = `stroke="${mObj.strokeColor}" stroke-width="${mObj.strokeWidth}"`;
          strokeCss = `stroke: ${mObj.strokeColor}`;
        }
        else
        {
          strokeCss = `stroke: none`;
        }
        
        gDefs = gradientDef;

        pathsHtml = `<path d="${mObj.svgText}"  ${fill} ${stroke} opacity="${opacity}" ${filterStr ? `filter="url(#${filterId})"` : ""} />`
      }
      else
      {

          gDefs = mObj?.rPath.map((pathObj, index) =>{
            const gradId = `grad-${id}-${index}`;
            let gradientDef = "";
            const angle = (path[index].gradientAngle || 0) * Math.PI / 180;
      
            const dx = Math.cos(angle);
            const dy = Math.sin(angle);

            gradientDef = `
            <defs>
              <linearGradient id="${gradId}" x1="${50 - dx * 50}%" y1="${50 - dy * 50}%" x2="${50 + dx * 50}%" y2="${50 + dy * 50}%">
                <stop offset="0%" stop-color="${path[index].gradientColor1}" />
                <stop offset="100%" stop-color="${path[index].gradientColor2}" />
              </linearGradient>
            </defs>
          `;

          return gradientDef;          
        }).join("\n");


        pathsHtml = mObj?.rPath.map((pathObj, index) => {
          const gradId = `grad-${id}-${index}`;

          let fillValue = "";
  
          if (path[index].allowFill && path[index].fillMode === "gradient") 
          {                                    
            fillValue = `fill="url(#${gradId})"`;          
          } 
          else 
          {          
            if (path[index].allowFill) 
            {
              fillValue = `fill="${path[index].fillColor}"`;
            } 
            else 
            {
              fillValue = `fill="transparent"`;
            }
          }


            const stroke = path[index].allowStroke
            ? (path[index].strokeColor || "#000")
            : "none";
    
            const strokeWidth = path[index].allowStroke
              ? (path[index].strokeWidth || 1)
              : 0;
          
            const fill = path[index].allowFill
              ? (path[index].fillColor || "none")
              : "none";
          
            const opacity = (path[index].alpha !== undefined)
              ? path[index].alpha
              : 1;

              return `
                <path 
                  d="${pathObj.d}" 
                  stroke="${stroke}" 
                  stroke-width="${strokeWidth}" 
                  ${fillValue}                  
                  opacity="${opacity}"
                  ${filterStr ? `filter="url(#${filterId})"` : ""}
                />              
              `;
            }).join("\n");
          }


          const clipPathDef = `
          <defs>
              <clipPath id="clip-${id}">
                  ${pathsHtml}                                      
              </clipPath>
              ${filterStr}
          </defs>
          `;
  
          animatedContent = `
                              ${clipPathDef}
                              <g id="anim-${id}"  ${filterStr ? `filter="url(#${filterId})"` : ""}>
                                <g clip-path="url(#clip-${id})"  ${filterStr ? `filter="url(#${filterId})"` : ""}>                                  
                                    ${pathsHtml}
                                    ${animString}
                                  </g>                    
                              </g>`

    }

    let motionPathStr = "";

    if (mPath != undefined)
    {
        if(mPath.type === 'Bezier' || mPath.type === 'Prect')
        {
          motionPathStr = `<path id="rPath-${id}"
                            d="${mPath.rPath[0].d}"
                              fill="none"
                              stroke="black"
                              stroke-width="${sWidth}"/>`;
        }
        else
        {
          if (mPath.subType === 'SvgRect' ||
              mPath.subType === 'SvgSquare')
          {

            let reduceX = 1;
            let reduceY = 1;

            let d = roundedRectPath(mPath.w,mPath.h, mPath.cornerTL, mPath.cornerTR, mPath.cornerBL, mPath.cornerBR, 0, reduceX, reduceY);
            motionPathStr = `<path id="rPath-${id}" d="${d}" fill="transparent" stroke="black" stroke-width="${sWidth}"/>`
          }
          if (mPath.subType === 'SvgCircle' ||
              mPath.subType === 'SvgEllipse')
              {
                let d = ellipseToPath(mPath.w/2,mPath.h/2, mPath.w/2, mPath.h/2);
                motionPathStr = `<path id="rPath-${id}" d="${d}" fill="transparent" stroke="black" stroke-width="${sWidth}"/>`

              }
        }
      }

    const start = item.animationSettings.startOffset / 100;
    const end = item.animationSettings.endOffset / 100;

    const keyPoints = `${start};${end}`;
    const keyTimes = "0;1";
    
    const animateMotionStr = mPath ? `
        <animateMotion 
          dur="${durTime}"
          repeatCount="${repeatCount}"
          rotate="${rotateMode}"
          calcMode="${ease}"
          keySplines="${keySplines}"
          keyPoints="${keyPoints}"
          keyTimes="${keyTimes}">
          <mpath href="#rPath-${id}"/>
        </animateMotion>
      ` : '';

      result.push(`
        <div id="${id}" ${aiInstruction} class="rectangle"
          style="padding:0;margin:0;left:${x}px; top:${y}px;
          width:${w}px; height:${h}px; z-index:${zIndex};
          overflow:hidden; transform:rotate(${-rotation}deg);">

          <svg width="${w}" height="${h}" overflow="visible" viewBox="${viewBoxStr}" data-large="${fullPath}">
                
                ${gDefs}
                ${mPath ? motionPathStr : ''}

                <g>
                  ${animateMotionStr}
                  ${animatedContent}
                </g>

          </svg>

        </div>
      `);

/*
    result.push (`
          <div id="${id}" ${aiInstruction} class="rectangle"
            style="padding:0;margin:0;left:${x}px; top:${y}px;
            width:${w}px; height:${h}px; z-index:${zIndex};
            overflow:hidden; transform:rotate(${-rotation}deg);">

            <svg width="${w}" height="${h}" overflow="visible" viewBox="${viewBoxStr}" data-large="${fullPath}">
                  
                    ${motionPathStr}
                    <g>
                      <animateMotion dur="${durTime}"
                            repeatCount="${repeatCount}"
                            rotate="${rotateMode}"
                            calcMode="${ease}"
                            keySplines="${keySplines}"                                
                            keyPoints="${keyPoints}"
                            keyTimes="${keyTimes}">
                            <mpath href="#rPath-${id}"/>
                        </animateMotion>

                      ${animatedContent}
                    </g>

            </svg>

          </div>
    `);
    */
}


/*
export function ellipseToPath(cx, cy, rx, ry) {
  return `
    M ${cx - rx} ${cy}
    A ${rx} ${ry} 0 1 0 ${cx + rx} ${cy}
    A ${rx} ${ry} 0 1 0 ${cx - rx} ${cy}
  `.trim();
}
*/

/*
export function ellipseToPath(cx, cy, rx, ry) {
  return `
    M ${cx} ${cy - ry}
    A ${rx} ${ry} 0 1 1 ${cx} ${cy + ry}
    A ${rx} ${ry} 0 1 1 ${cx} ${cy - ry}
  `.trim();
}
*/

export function ellipseToPath(cx, cy, rx, ry) {
  return `
    M ${cx - rx} ${cy}
    A ${rx} ${ry} 0 1 1 ${cx + rx} ${cy}
    A ${rx} ${ry} 0 1 1 ${cx - rx} ${cy}
  `.trim();
}

export function roundedRectPath(
  w, 
  h, 
  tl = 0, 
  tr = 0, 
  br = 0, 
  bl = 0, 
  arcFactor = 0, 
  padX = 0, 
  padY = 0
) {
  const wAdjusted = w - 2 * padX;
  const hAdjusted = h - 2 * padY;

  // Clamp base radii first
  tl = Math.min(tl, wAdjusted / 2, hAdjusted / 2);
  tr = Math.min(tr, wAdjusted / 2, hAdjusted / 2);
  br = Math.min(br, wAdjusted / 2, hAdjusted / 2);
  bl = Math.min(bl, wAdjusted / 2, hAdjusted / 2);

  // Apply arcFactor + prevent negatives
  const tlf = Math.max(0, tl + arcFactor);
  const trf = Math.max(0, tr + arcFactor);
  const brf = Math.max(0, br + arcFactor);
  const blf = Math.max(0, bl + arcFactor);

  return `
    M ${padX + tlf},${padY}
    H ${padX + wAdjusted - trf}
    A ${trf} ${trf} 0 0 1 ${padX + wAdjusted} ${padY + trf}
    V ${padY + hAdjusted - brf}
    A ${brf} ${brf} 0 0 1 ${padX + wAdjusted - brf} ${padY + hAdjusted}
    H ${padX + blf}
    A ${blf} ${blf} 0 0 1 ${padX} ${padY + hAdjusted - blf}
    V ${padY + tlf}
    A ${tlf} ${tlf} 0 0 1 ${padX + tlf} ${padY}
    Z
  `;
}


export function expandBounds(x, y, w, h, blur, shadowBlur, shadowOffsetX, shadowOffsetY) {

  const spread = blur + shadowBlur;

  const newX = x + Math.min(0, shadowOffsetX) - spread;
  const newY = y + Math.min(0, shadowOffsetY) - spread;

  const newW = w + Math.abs(shadowOffsetX) + spread * 2;
  const newH = h + Math.abs(shadowOffsetY) + spread * 2;

  return { x: newX, y: newY, w: newW, h: newH };
}


export function getUpdatedViewBox(x, y, w, h, n) {
  // Keep original center and radius to preserve visual size
  const cX = w / 2;
  const cY = h / 2;

  // Keep viewBox as original width/height to prevent shrinking
  const viewBoxStr = `0 0 ${w} ${h}`;

  return { viewBoxStr, cX, cY };
}

export function drawGroupRect(user, item, unique, demo, preview)
{

  const { x, y, w, h, id: idT, zIndex, rotation, 
    imageName, description, keepAspect, enablePopup, 
    clickable, useLocal, localLink, externalLink,
    fillColor, strokeColor, strokeWidth,allowStroke,allowFill, fillAlpha, bAlpha, imagePanX, imagePanY, imageZoom, 
    iX,iY, iW, iH,
    cornerTL, cornerTR, cornerBR, cornerBL} = item;
  let id = (idT.trim() + `_${unique}`).trim();

  let filterId = `filter-${id}`;
  let filterStr = "";

  if (item.isBlur || item.isDropShadow) 
  {
    filterStr = `
    <filter id="${filterId}" x="-50%" y="-50%" width="200%" height="200%">
      ${item.isDropShadow ? `<feDropShadow dx="${item.shadowOffsetX}" dy="${item.shadowOffsetY}" stdDeviation="${item.shadowBlur}" flood-color="${item.shadowColor}" />` : ""}
      ${item.isBlur ? `<feGaussianBlur stdDeviation="${item.regularBlur}" />` : ""}
    </filter>
    `;
  }
      
  let opacity = fillAlpha;
  let imageOpacity = bAlpha;
  let aiInstruction = "";
  if (description !== "") 
  {
    aiInstruction = `data-ai-instruction="${description}"`;
  }

  let refresh = "";
  if (!preview) {
    refresh = "?v=" + new Date().getTime();
  }

  let fullPath = imageName;
  if (demo === true) {
      fullPath = `images/${imageName}` + refresh;
  } else {
      fullPath = `./${imageName}` + refresh;
  }



  let onClick = '';
  if(clickable)
  {
    if(localLink && localLink != "")
    {
      let func = `goToPage('${localLink}')`;
      onClick = `onClick="${func}"`;
    }
    if(externalLink && externalLink != "")
    {
      let func = `goToExternalPage('${externalLink}')`;
      onClick = `onClick="${func}"`;
    }

  }



  let fill = "";
  let gradientDef = "";
  let fillValue = fill;
  
  if (item.allowFill && item.fillMode === "gradient") {
  
    const angle = (item.gradientAngle || 0) * Math.PI / 180;
  
    const dx = Math.cos(angle);
    const dy = Math.sin(angle);
  
    const gradId = `grad-${id}`;
  
    gradientDef = `
      <defs>
        <linearGradient id="${gradId}" x1="${50 - dx * 50}%" y1="${50 - dy * 50}%" x2="${50 + dx * 50}%" y2="${50 + dy * 50}%">
          <stop offset="0%" stop-color="${item.gradientColor1}" />
          <stop offset="100%" stop-color="${item.gradientColor2}" />
        </linearGradient>
      </defs>
    `;
  
    fillValue = `fill="url(#${gradId})"`;
  
  } else if (item.allowFill) {
    fillValue = `fill="${item.fillColor}"`;
  } else {
    fillValue = `fill="transparent"`;
  }


  if(allowFill)
  {
    fill = `fill="${fillColor}"`;
  }
  else
  {
    fill = `fill="transparent"`;
  }

  let stroke = "";

  if(allowStroke)
  {
    stroke = `stroke="${strokeColor}" stroke-width="${strokeWidth}"`;
  }

  let popup="";

  if(enablePopup===true)
  {
    popup = "class='popup-image'";
  }
          
  // Calculate the new width/height of the viewBox based on zoom
  let newViewBoxWidth = w ;  // 160 is the original width of the rectangle
  let newViewBoxHeight = h; // 120 is the original height of the rectangle

  // Calculate the new origin of the viewBox (this is where pan will apply)
  let newViewBoxX = 0
  let newViewBoxY = 0


  let strokeNum  = parseInt(strokeWidth);
  if(allowStroke)
  {
    newViewBoxWidth += strokeNum;
    newViewBoxHeight += strokeNum;          
  }
                    
  // Update the viewBox with the new values
  let viewBoxStr = `${newViewBoxX} ${newViewBoxY} ${newViewBoxWidth} ${newViewBoxHeight}`;

  let reduceX = 0;
  let reduceY = 0;
  let a = newViewBoxWidth/2;
  let b = newViewBoxHeight/2;

  if(item.isDropShadow)
  {
    a = a-(Math.abs(item.shadowOffsetX) + item.shadowBlur);
    b = b-(Math.abs(item.shadowOffsetY) + item.shadowBlur);
  }
  if(item.isBlur)
  {
    a = a-item.regularBlur;
    b = b-item.regularBlur;          
  }

  reduceX = (newViewBoxWidth - 2*a)/2;
  reduceY = (newViewBoxHeight - 2*b)/2;

  if(allowStroke)
  {
    reduceX +=strokeWidth/2 +1 ;
    reduceY +=strokeWidth/2 +1;
  }

  let d = roundedRectPath(newViewBoxWidth,newViewBoxHeight, cornerTL, cornerTR,cornerBL,cornerBR,0, reduceX, reduceY);


  // transform="translate(${cX-r},${cY-r})"
  if(imageName !="")
  {
    let result =`  
        <div id="${id}" ${aiInstruction} class="rectangle" 
            style="padding:0;margin:0;left: ${x-strokeNum/2}px; top: ${y-strokeNum/2}px; width: ${w+strokeNum}px; height: ${h+strokeNum}px; z-index: ${zIndex}; transform: rotate(${-rotation}deg); opacity:${opacity}">
                    
            <svg width="${newViewBoxWidth}" height="${newViewBoxHeight}" overflow="visible" viewBox="${viewBoxStr}" ${onClick} ${popup} data-rotation="${-rotation}" data-large="${fullPath}">
              <defs>
                    <clipPath id="clip-${id}">
                      <!-- Define your clipping path, in this case, a rectangle -->
                      <path d="${d}" ${fill} ${stroke} opacity="${opacity}" />                                
                    </clipPath>
                    ${filterStr}                                     
              </defs>
                      
              <path d="${d}" ${fill} ${stroke} opacity="${opacity}" ${filterStr ? `filter="url(#${filterId})"` : ""}/>                                
    
              <!-- Wrap the image in a <g> and apply the clip-path to the group -->
              <g ${filterStr ? `filter="url(#${filterId})"` : ""}>
                  <g clip-path="url(#clip-${id})" opacity = "${imageOpacity}">
                      <image
                          href="${fullPath}"
                          x="${iX}"
                          y="${iY}"
                          width="${iW}"    <!-- Dynamically set the width based on zoom -->
                          height="${iH}"   <!-- Dynamically set the height based on zoom -->   
                          preserveAspectRatio="none"                                
                        />
                  </g>
              </g>                                                                              
            </svg>`;      
      return result;                
    }
    else
    {
          return (`
              <div id="${id}" class="rectangle text" style="left:${x-strokeNum/2}px; top: ${y-strokeNum/2}px; width: ${w+strokeNum}px; height: ${h+strokeNum}px; z-index: ${zIndex}; margin:0; padding:0; overflow:hidden; transform: rotate(${-rotation}deg); opacity:${opacity}">
                    <svg ${onClick} width="${newViewBoxWidth}" height="${newViewBoxHeight}" viewBox="${viewBoxStr}">
                    ${gradientDef}
                    <defs>
                        ${filterStr} 
                    </defs>

                    <path d="${d}" ${fillValue} ${stroke}  ${filterStr ? `filter="url(#${filterId})"` : ""}/>                                

                    </svg>        
          `)
    }

}